import { render, staticRenderFns } from "./FormIsiEkspektasiPerilaku.vue?vue&type=template&id=f4cf2f66&lang=html&"
import script from "./FormIsiEkspektasiPerilaku.vue?vue&type=script&lang=js&"
export * from "./FormIsiEkspektasiPerilaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports